export const API_BASE_URL = `https://${process.env.SIMILAR_ITEMS_CLUSTER}.api.esales.apptus.cloud/api/v2/panels/similar_items`;
export const PRESENTATION_ATTRIBUTES = [
    'brand_name',
    'brandID',
    'collection',
    'external',
    'is_new',
    'main_category',
    'main_category_code',
    'panel_name',
    'product_marker',
    'product_marker_colors',
    'product_marker_style',
    'product_marker_text',
    'promotion_marker',
    'promotion_marker_colors',
    'promotion_marker_style',
    'promotion_marker_text',
    'qualities',
    'selling_attribute',
    'show_price_marker',
    'v_article_code',
    'v_article_name',
    'v_available_size_rate',
    'v_color_loc',
    'v_fashion_image',
    'v_formatted_old_price',
    'v_formatted_price',
    'v_formatted_yellowprice',
    'v_hybris_color_code',
    'v_is_on_sale',
    'v_link_pdp',
    'v_old_price',
    'v_price',
    'v_rgbcolor',
    'v_shop_now_link',
    'v_still_life_image',
    'v_stock_state',
    'v_yellowprice',
    'v_comparative_quantity',
    'v_environmental_markers',
    'v_comparative_formatted_price',
    'v_quantity',
    'v_prior_price',
    'v_formatted_prior_price',
];
export const PRESENTATION_ATTRIBUTES_WITH_LOCALE = [
    'panel_name',
    'v_formatted_old_price',
    'v_formatted_price',
    'v_old_price',
    'v_price',
    'v_formatted_yellowprice',
    'v_prior_price',
    'v_formatted_prior_price',
    'v_comparative_formatted_price',
];
export const CAROUSEL_CONFIG = {
    arket: {
        numOfItemsPerSlide: {
            xsmall: 2,
            small: 2,
            smallPlus: 2,
            medium: 2,
            large: 4,
            xlarge: 4,
            xxl: 4,
        },
    },
    cos: {
        numOfItemsPerSlide: {
            xsmall: 2,
            small: 2,
            smallPlus: 2,
            medium: 2,
            large: 4,
            xlarge: 4,
            xxl: 4,
        },
    },
    monki: {
        numOfItemsPerSlide: {
            xsmall: 2,
            small: 2,
            smallPlus: 2,
            medium: 2,
            large: 5,
            xlarge: 6,
            xxl: 6,
        },
    },
    otherStories: {
        numOfItemsPerSlide: {
            xsmall: 2,
            small: 2,
            smallPlus: 2,
            medium: 2,
            large: 2,
            xlarge: 3,
            xxl: 3,
        },
    },
};
//# sourceMappingURL=constants.js.map